import { useMutation, useQueryClient } from '@tanstack/react-query';
import { serviceCatalogServices } from '../services/service-catalog.service';
import toast from 'react-hot-toast';

export const useToggleServiceCatalogStatus = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id }) => serviceCatalogServices.toggleStatus(id),

    onMutate: async ({ id }) => {
      await queryClient.cancelQueries({ queryKey: ['service-catalog'] });
      const previousData = queryClient.getQueriesData({ queryKey: ['service-catalog'] });

      queryClient.setQueriesData({ queryKey: ['service-catalog'] }, (old) => {
        if (!old) return old;

        return {
          ...old,
          data: old.data?.map((entry) =>
            entry._id === id
              ? { ...entry, status: entry.status === 'active' ? 'inactive' : 'active' }
              : entry
          ),
        };
      });

      return { previousData };
    },

    onError: (error, variables, context) => {
      if (context?.previousData) {
        context.previousData.forEach(([queryKey, data]) => {
          queryClient.setQueryData(queryKey, data);
        });
      }
      toast.error(error?.response?.data?.message || 'Failed to update service catalog status');
    },

    onSuccess: () => {
      toast.success('Service catalog status updated successfully');
    },

    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['service-catalog'] });
    },
  });
};
